import type { Account } from '@adtrackify/at-tracking-event-types';

import { AccountStorage } from '@/features/workspace/api/account-storage/account-storage';

export function persistWorkspaceSelection(accountId: string, account: Account): void {
  AccountStorage.switchAccount(accountId);
  AccountStorage.setLastAccountId(accountId);
  AccountStorage.set(accountId, 'account', {
    currentAccount: account,
    lastAccessedAt: Date.now(),
  });
}
